import * as React from "react";
import {useGlobalStores} from "../../../../hooks/use_global_stores";
import {FreeTextField} from "../../../Components/Form/FreeTextField";
import {SelectField} from "../../../Components/Form/SelectField";
import {useForm} from "../../../../hooks/use_form_v2";
import {ICategory} from "../../../../config/category";
import {IndentedItem} from "../../../Components/IndentedItem";
import { Form as FormComponent } from "../../../Components/Form/Form/Form";
import { CheckboxField } from "../../../Components/Form/CheckboxField";
import { CustomCategoryForm, ICustomCategoryForm, ICustomCategoryRequest } from "../../../../forms/settings_custom_category_form";

interface IFormProps {
    value?: ICategory;
    onSubmit(data: ICustomCategoryRequest): Promise<any>;
    onSuccess?(): void;
}

export const Form = ({value, onSubmit, onSuccess}: IFormProps) => {
    const { categoryStore } = useGlobalStores();

    const form = useForm<ICustomCategoryForm, ICustomCategoryRequest>(new CustomCategoryForm(value));
    const { register, toRequest } = form;

    const handleSubmit = (values: ICustomCategoryForm) => {
        return onSubmit(toRequest(values)).then(() => onSuccess && onSuccess());
    };

    return (
        <FormComponent form={form} onSubmit={handleSubmit}>
            <FormComponent.Field
                type={SelectField}
                {...register('parentCategoryId')}
                label="Parent Category"
                options={categoryStore.categories}
                optionValueGetter={(o: any) => o.id.toString()}
                optionLabelGetter={(o: any) => <IndentedItem value={o.name} />}
            />
            <FormComponent.Field type={FreeTextField} {...register('name')} />
            <FormComponent.Field type={FreeTextField} {...register('code')} />
            <FormComponent.Field type={CheckboxField} {...register('isGlobal')} conditional={false} label="Mark as global" />
        </FormComponent>
    );
};
